/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "../summaryStyle";
import GridEditRow from "../../Common/GridEditRow/GridEditRow";
import Typography from "@mui/material/Typography";
import { momentToGermanDate } from "../../../../services/formatService";
import {Box} from "@mui/material";

type PersonalDataSummaryProps = {
  formData: Record<string, any>;
  basePath: string;
};
const PersonalDataSummary = ({ formData, basePath }: PersonalDataSummaryProps) => {
  return (
    <>
      <Grid item xs={12} sx={summaryStyle.subHeadline}>
        <Typography variant={"h5"}>Persönliche Angaben</Typography>
      </Grid>
      <Grid item xs={12} sx={summaryStyle.question}>
        <Box id={"insurance"} sx={summaryStyle.scrollToAnchor} />
        Rechtsschutzversicherung
      </Grid>
      <GridEditRow
        item
        xs={12}
        to={{
          pathname: basePath + "rechtsschutzversicherung",
          state: {
            field: "insurance",
          },
        }}
      >
        {formData.isCostCovered === "yes" ? "Kosten werden mit " + formData.costCoverageAmount + " € übernommen" : "Kosten werden nicht übernommen"}
        <br />
        {formData.hasPotentialCoverage === "yes" ? "Kosten könnten ggf. übernommen werden von: " + formData.potentialCoverer : "Keine Kostenübernahme möglich"}
        <br />
      </GridEditRow>
      <Grid item xs={12} sx={summaryStyle.question}>
        <Box id={"nameAdress"} sx={summaryStyle.scrollToAnchor} />
        Name und Adresse
      </Grid>
      <GridEditRow
        item
        xs={12}
        to={{
          pathname: basePath + "persoenliche-angaben",
          state: {
            field: "nameAdress",
          },
        }}
      >
        {formData.petitioner.gender === "male" ? "Herr" : "Frau"} {formData.petitioner.givenName} {formData.petitioner.familyName}
        {formData.petitioner.birthName != null && " (geb. " + formData.petitioner.birthName + ")"}
        <br />
        Geburtsdatum: {momentToGermanDate(formData.petitioner.birthDate)}
        <br />
        {formData.petitioner.addresses[0].streetAddress}
        <br />
        {formData.petitioner.addresses[0].postalCode} {formData.petitioner.addresses[0].addressLocality}
        <br />
        Tel: {formData.telephone}
        <br />
      </GridEditRow>
      <Grid item xs={12} sx={summaryStyle.question}>
        <Box id={"job"} sx={summaryStyle.scrollToAnchor} />
        Beruf
      </Grid>
      <GridEditRow
        item
        xs={12}
        to={{
          pathname: basePath + "aktueller-beruf",
          state: {
            field: "job",
          },
        }}
      >
        {formData.job}
      </GridEditRow>
      <Grid item xs={12} sx={summaryStyle.question}>
        <Box id={"legalRepresentative"} sx={summaryStyle.scrollToAnchor} />
        Gesetzlicher Vertreter
      </Grid>
      <GridEditRow
        item
        xs={12}
        to={{
          pathname: basePath + "gesetzlicher-vertreter",
          state: {
            field: "legalRepresentative",
          },
        }}
      >
        {formData.hasLegalRepresentative === "no" ? (
          "Kein gesetzlicher Vertreter"
        ) : (
          <>
            {formData.legalRepresentative.gender === "male" ? "Herr" : "Frau"} {formData.legalRepresentative.givenName}{" "}
            {formData.legalRepresentative.familyName}
            <br />
            {formData.legalRepresentative.addresses[0].streetAddress}
            <br />
            {formData.legalRepresentative.addresses[0].postalCode} {formData.legalRepresentative.addresses[0].addressLocality}
            <br />
            Tel: {formData.telephoneRepresentative}
            <br />
          </>
        )}
      </GridEditRow>
      <Grid item xs={12} sx={summaryStyle.question}>
        <Box id={"alimonyClaims"} sx={summaryStyle.scrollToAnchor} />
        Unterhaltsanspruch
      </Grid>
      <GridEditRow
        item
        xs={12}
        to={{
          pathname: basePath + "unterhaltsanspruch",
          state: {
            field: "alimonyClaims",
          },
        }}
      >
        {formData.hasAlimonyClaims === "no" ? (
          "Kein Unterhaltsanspruch"
        ) : (
          <>
            Unterhaltsverpflichtet ist:
            <br />
            {formData.alimonyObligatedPerson.gender === "male" ? "Herr" : "Frau"} {formData.alimonyObligatedPerson.givenName}{" "}
            {formData.alimonyObligatedPerson.familyName}
            <br />
            Verhältnis: {formData.alimonyObligatedPersonRelation}
            <br />
          </>
        )}
      </GridEditRow>
      <Grid item xs={12} sx={summaryStyle.question}>
        <Box id={"relativesAlimonyClaims"} sx={summaryStyle.scrollToAnchor} />
        Unterhaltsverpflichtungen
      </Grid>
      <GridEditRow
        item
        xs={12}
        to={{
          pathname: basePath + "unterhaltszahlungen",
          state: {
            field: "relativesAlimonyClaims",
          },
        }}
      >
        {formData.hasRelativesAlimonyClaims === "no" ? (
          "Keine Unterhaltsverpflichtungen"
        ) : (
          <>
            Unterhaltsverpflichtet gegenüber:
            {formData.alimonyPersons?.map((alimonyPerson: Record<string, any>, key: number) => (
              <React.Fragment key={key}>
                <br />
                <br />
                {alimonyPerson.givenName} {alimonyPerson.familyName} ({alimonyPerson.relation})<br />
                {alimonyPerson.livesWithPetitioner ? (
                  <>Wohnt bei mir</>
                ) : (
                  <>
                    {alimonyPerson.address.streetAddress}, {alimonyPerson.address.postalCode} {alimonyPerson.address.addressLocality}
                  </>
                )}
                <br />
                geboren am {alimonyPerson.birthDate}
                <br />
                Geleisteter Unterhalt: {alimonyPerson.alimony === "0" ? "Naturalunterhalt" : alimonyPerson.alimony + " €"}
                <br />
                {alimonyPerson.hasIncome === "no" ? "Hat kein eigenes Einkommen" : "Einkommen: " + alimonyPerson.income + " €"}
              </React.Fragment>
            ))}
          </>
        )}
      </GridEditRow>
    </>
  );
};

export default PersonalDataSummary;
